import { baseUrl } from "../../../config.js";
import { setDocTitle } from "../../../functions/HelperFuncs.js";
import "./NotificationsOverview.scss";

export default {
  data() {
    return {
      user: this.$store.state.user,
      company: this.$store.state.company,
      company_full: this.$store.state.company_full,
      current: this.$route.path,
      items: [],
      currentUser: false,
      messageCount: null,
      userNameCount: null,
      charCount: null,
      loading: true,
      collections: null,
      weekCount: 0,
      monthCount: 0,
      yearCount: 0,
    };
  },
  created() {
    setDocTitle("notifications", this);

    this.$axios.get(baseUrl + "/notificationsoverview").then((response) => {
      this.loading = false;

      this.items = response.data;
      this.setUser(this.items);
      this.setCharAmount(this.items);
      this.setCounters();

      console.log(this.items);
    });
  },
  methods: {
    setCounters() {
      let weekCounter = 0;
      let monthCounter = 0;
      let yearCounter = 0;

      this.items.forEach(function (value) {
        if (!value.this_week && !value.this_month && value.this_year) {
          yearCounter++;
        } else if (!value.this_week && value.this_month) {
          monthCounter++;
        } else if (value.this_week) {
          weekCounter++;
        }
      });

      this.weekCount = weekCounter;
      this.monthCount = monthCounter;
      this.yearCount = yearCounter;
    },
    openItem(itemId, sort, folderId) {
      if (itemId == null) {
        return;
      }
      if (sort === "foldercreate") {
        this.$router.push(
          "/" + this.$store.state.company + "/home/expanded/" + itemId
        );
      }
      if (sort === "fileupload") {
        this.$router.push(
          "/" +
            this.$store.state.company +
            "/home/expanded/" +
            folderId +
            "?file=" +
            itemId
        );
      }
    },

    /**
     * Check if the changes where made by the current user
     * @param items
     */
    setUser(items) {
      items.forEach((item, index) => {
        if (this.user != null && item.user_name == this.user.name) {
          this.items[index].current = true;
        } else {
          this.items[index].current = false;
        }
      });
    },
    /**
     * Count the characters of the displayed message
     * -- If it is the current user only count the message
     * -- Else count the username and the message
     *
     * @param items
     */
    setCharAmount(items) {
      items.forEach((item, index) => {
        if (item.current) {
          this.charCount = item.message.length;
          this.items[index].char_amount = this.charCount;
        } else {
          this.userNameCount = item.user_name.length;
          this.messageCount = item.message.length;
          this.charCount = this.userNameCount + this.messageCount;
          this.items[index].char_amount = this.charCount;
          this.items[index].other_message = item.user_name + " " + item.message;
        }
      });
    },

    loadMore(event) {
      let list = $(event.target).parent().parent().find("ul");
      let listHeight = list.css("max-height").replace("px", "");
      listHeight = parseInt(listHeight);
      list.css("max-height", listHeight + 600 + "px");
      let button = $(event.target).parent().parent().find(".load-more");
      if (button.attr("data-period") === "week") {
        if (listHeight + 600 >= this.thisWeekCount * 60) {
          button.addClass("disable");
          list.addClass("no-more");
        }
      }
      if (button.attr("data-period") === "month") {
        if (listHeight + 600 >= this.thisMonthCount * 60) {
          button.addClass("disable");
          list.addClass("no-more");
        }
      }
      if (button.attr("data-period") === "year") {
        if (listHeight + 600 >= this.thisYearCount * 60) {
          button.addClass("disable");
          list.addClass("no-more");
        }
      }
    },
  },
};
